import { types } from 'mobx-state-tree'

const RGBA = types.array(types.number)

export default RGBA
